import React, { useState, useEffect, useReducer } from 'react';
import _ from 'lodash'
import { Link, useParams, useNavigate } from 'react-router-dom'
import ScrollView from 'devextreme-react/scroll-view';
import Gallery from 'devextreme-react/gallery';
import Header from '../header/Header'
import Footer from '../footer/Footer'
import { postUserLog } from '../../actions/common'
import * as utils from '../../common/utils'
import * as actions from '../../actions/siteDetails';
import siteReducer from '../../reducers/siteDetails';
const initialState = { siteLocations: [], tiers: [], userData: null, pinSiteStatus: null, pinnedSites: [], recognition:[] };
export default () => {
    const { category, app, site } = useParams();
    const navigate = useNavigate()
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { siteLocations, pinnedSites, userData, recognition } = state
    const [animate, setAnimate] = useState('animate');
    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    useEffect(() => {
        actions.getKRecognitions(dispatch, site);
        actions.getUserData(dispatch, site);
        actions.fetchSiteLocations(dispatch, category);
        actions.fetchPinnedSites(dispatch, category);

    }, []);

    const updatePinSite = () => {
        let site = getSitInfo();
        let isPinned = site.isPinned ? false : true;
        let pinStatus = isPinned ? 'pinned' : 'unpinned';
        actions.updatePinSite(dispatch, `siteid=${site.siteId}&pinned=${isPinned}`, category);
        postUserLog({ event: 'Pin/UnPin Site', data: { action: site.siteName + ' site ' + pinStatus, module: 'Tier Screen', section: 'Header', siteUId: site.siteId, widget: '', } })
    }
    const getSitInfo = () => {
        let data = _.find(siteLocations, ['siteId', site]);
        return data
    }

    const getSiteName = () => {

        let data = getSitInfo();
        return data ? data.siteName : '';

    }
 
    const itemTpl = (info) => {
        return <div className="kreg-info alerts-flex-container" >
            <div className="kreg-head w-100">Test 123</div>
            <div className="kreg-item">
                <label >Category</label>
                <span> {info.category}</span>
            </div>

            <div className="kreg-item">
                <label >TTI Category</label>
                <span> {info.ttiCategory}</span>
            </div>

            <div className="kreg-item">
                <label >Raised On</label>
                <span> {info.raisedOn}</span>
            </div>
            <div className="kreg-item">
                <label >Completed Date</label>
                <span> {info.completedOn}</span>
            </div>

            <div className="kreg-item">
                <label >Proposed By</label>
                <span> {info.proposedBy}</span>
            </div>

            <div className="kreg-item">
                <label >Area</label>
                <span> {info.area}</span>
            </div>
            <div className="kreg-item">
                <label >Cell</label>
                <span> {info.cell}</span>
            </div>
            <div className="kreg-item">
                <label >Lines</label>
                <span> {info.lines}</span>
            </div>
            <div className="kreg-item">
                <label > Collaborated With</label>
                <span> {info.collaboratedWith}</span>
            </div>
            <div className="kreg-item">
                <label >Potential yearly savings($)</label>
                <span> {info.potentialSaving}</span>
            </div>
            <div className="kreg-item"></div>
            <div className="kreg-item-50">
                <label >Description</label>
                <span className="kreg-span">{info.description}</span>
            </div>

            <div className="kreg-item-50">
                <label >Solution</label>
                <span className="kreg-span">{info.solution}</span>
            </div>
            <div className="kreg-item">
                <label >Attachments</label>
                <span>No files attached.</span>
            </div>
            <div className="kreg-a" style={{ width: '100%', textAlign: 'right', padding: '20px' }}><a target="_blank" href="https://honeywell.service-now.com/bravo">Go to Bravo Tool</a></div>
        </div>
    }

    return (
        <>
            <Header showPinBtn={updatePinSite} site={getSitInfo()} />
            <section className="page-content">
                <div className="site-view tier-wrap">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className={"icon icon-" + utils.getSbgName(category)}></span>
                            <ul>
                                <li><Link to={`/home/${category}`} onClick={() => { postUserLog({ event: 'SBG Clicked', data: { action: 'Navigates to ' + utils.getSbgNameTxt(category) + ' Site Selection Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{utils.getSbgNameTxt(category)}</Link></li>
                                <li><Link to={`/sitehome/${category}/${site}`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{getSiteName()}</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>Kaizen</Link></li>
                                <li>Recognition</li>
                            </ul>
                        </div>
                        <div className="site-head">
                            <div className="page-heading">
                                <h2><span className={"icon action"}></span>Recognition</h2>
                            </div>
                            <div style={{ paddingRight: '20px' }}>Total count: {recognition.length }</div>

                        </div>

                        {userData && <div className="site-body scroll">
                            <ScrollView
                                id="siteApps"
                                {...scrollConfig}
                            >
                                <div className="site-body w-100 kregc" >
                                    {recognition.length > 0 &&
                                        <Gallery
                                        dataSource={recognition}
                                        height='100%'
                                        width='100%'
                                        loop={false}
                                        showNavButtons={true}
                                        showIndicator={false}
                                        itemRender={itemTpl} />
                                    }
                                    {recognition.length == 0 && <div style={{ width: '100%', textAlign: 'center', marginTop: '80px' }}>No data.</div>}
                                    
                                </div>
                                
                            </ScrollView>
                        </div>
                        }
                    </div>
                </div>
            </section>

            <Footer showThemeSwitch={true} hideSiteCount={true} activeSites={pinnedSites} sbg={category} />
        </>
    );
}